export const myprofile = {
    title: 'My Profile',
    picture: {
        upload_picture: 'Upload picture',
        file_support: 'Support: JPEG, PNG',
    },
    storeId: {
        name: 'Store ID',
        placeholder: '',
        required: 'Please enter store ID',
        too_short: '',
        invalid: '',
    },
    storeName: {
        name: 'Store Name',
        placeholder: '',
        required: 'Please enter store Name',
        too_short: '',
        invalid: '',
    },
    firstname: {
        name: 'Firstname',
        placeholder: '',
        required: 'Please enter firstname',
        too_short: '',
        invalid: '',
    },
    lastname: {
        name: 'Lastname',
        placeholder: '',
        required: 'Please enter lastname',
        too_short: '',
        invalid: '',
    },
    mobileNumber: {
        name: 'Mobile Number',
        placeholder: '',
        required: 'Please enter mobile number',
        too_short: '',
        invalid: 'Please enter mobile number',
    },
    changeMobileNumber: {
        name: 'Mobile Phone Number',
        placeholder: '',
        required: 'Please enter mobile number',
        too_short: '',
        invalid: 'Please enter mobile number',
        change: 'Change'
    },
    email: {
        name: 'Email',
        placeholder: '',
        required: 'Please enter email',
        too_short: '',
        invalid: '',
    },
    store_type: 'Store Type',
    btn_save: 'Update',
    change_mobile_number: {
        title: 'Change Mobile Phone Number',
        msg: 'Please enter the mobile phone number you would like to change.',
        confirm: 'Confirm',
        close: 'Cancel'
    }
}
